import { Injectable } from '@angular/core';

/**
 * Storage keys enum for consistent key management
 */
export enum StorageKey {
  USER = 'user',
  THEME = 'theme',
  LANGUAGE = 'language',
  REMEMBER_ME = 'remember_me',
  SIDEBAR_COLLAPSED = 'sidebar_collapsed'
}

/**
 * Simple centralized LocalStorage Service
 */
@Injectable({
  providedIn: 'root'
})
export class LocalStorageService {

  /**
   * Set an item in localStorage
   */
  setItem(key: string, value: any): void {
    const serialized = typeof value === 'string' ? value : JSON.stringify(value);
    localStorage.setItem(key, serialized);
  }

  /**
   * Get an item from localStorage
   */
  getItem<T>(key: string): T | null {
    const item = localStorage.getItem(key);
    if (!item) return null;

    try {
      return JSON.parse(item) as T;
    } catch {
      return item as unknown as T;
    }
  }

  /**
   * Get a string from localStorage
   */
  getString(key: string): string | null {
    return localStorage.getItem(key);
  }

  /**
   * Remove an item from localStorage
   */
  removeItem(key: string): void {
    localStorage.removeItem(key);
  }

  /**
   * Clear all items from localStorage
   */
  clear(): void {
    localStorage.clear();
  }

  /**
   * Check if a key exists
   */
  hasItem(key: string): boolean {
    return localStorage.getItem(key) !== null;
  }
}
